// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    margin-top: 25px;
    width: 100%;
}

.container {
    max-width: 1000px;
}

.video-container {
    padding: 30px;
    border-radius: 10px;
    background-color: #ffff;
    height: 66vh;
    margin-top: 40px;
    overflow-y: auto;
    overflow-x: hidden;
}

/* .video-container :hover {
    background-color: #fff;
} */
.tab-pane
{
    padding-left: 15px;
}
.reacted
{
   
    width: auto!important;
   
    height: 17px!important;
}

.nav-pills .nav-link {
    color: #000 !important
}

.nav-pills .nav-link.active {
    color: #6c2fbb !important;
    background-color: transparenT !important;

}

/*.history-row img{*/
/*    width: 100%;*/
/*    object-fit: cover;*/
/*    height: 86px;*/
/*}*/

/* .history-row {
    
    padding: 15px 0;
    margin: 5px 0px;
    cursor: pointer;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);
    
} */
.width-100 {
   
    width: 100%;
    padding: 0px 15px;
    padding: 15px 0;
    margin: 5px 0px;
    cursor: pointer;
    /*box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);*/
    /* margin-bottom: 15px; */
    /* margin-left: 2px; */
}
.width-100:hover {
    background-color: #f8f9fa;
    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%);
    /*border-radius: 10px;*/
}

.video-img img {
    width: inherit;
    border-radius: 4px;
    cursor: pointer;
}

/*.video-details h5 {*/
/*    font-size: 15px;*/
/*}*/

/*.video-details p {*/
/*    font-size: 12px;*/
/*    margin-bottom: 7px;*/
/*}*/

/*.video-details span {*/
/*    font-size: 12px;*/
/*    color: #636161;*/
/*    border:  1px solid #636161;*/
/*    border-radius: 4px;*/
/*    padding: 4px;*/
/*    margin-right: 15px;*/

/*}*/

.video-desc {
    text-align: justify;
}

.icon :hover {
    /* fill: #6655ee; */
    fill: #6c2fbb
}

.icon > svg {
    width: 11%;
    margin-right: 5px;
}

a.active > svg {
    fill: #6c2fbb
}

a.nav-link :hover {
    color: #6c2fbb;
}

@media (max-width: 991px) {
    .nav-pills .nav-link {
        margin-bottom: 10px;
    }
}


/*new  tab css=========================*/

.activity-box .tab-box-video {
    width: 100%;

}

.activity-box .tab-box-video ul {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.activity-box .tab-box-video ul li {
    list-style: none;
    font-weight: 500;
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.activity-box .tab-box-video ul li svg {
    fill: #878395;
}

.activity-box .tab-box-video ul li.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.activity-box .tab-box-video ul li.active svg {
    fill: rgba(108, 47, 187, 1);
}


.img-box-pub {
    aspect-ratio: 16/9;
    display: flex;
    justify-content: center;
    /*height: 213px;*/
    position: relative;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 10px;
    width: 100%;
}

.img-box-pub img {
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}


.group-box h4 {
    margin-bottom: 20px;
    font-weight: 500;
    color: #0f062b;
    font-size: 16px;
    margin-bottom: 7px;
}

.group-box p {
    margin: 0;
    font-size: 13px;
    color: rgba(136, 133, 142, 1);
}


.two-btns {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #000000a2;
    display: flex;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 2px 10px;
    border-radius: 5px 10px;

}

.two-btns button {
    background-color: transparent;
    display: flex;
    align-items: center;
    -moz-column-gap: 5px;
         column-gap: 5px;
    border: none;
}

.two-btns button span {
    color: #fff;
    font-size: 12px !important;
}

@media (max-width: 1400px) {

    .group-box p {
        line-height: 5px;
    }

    .group-box .two-btns {
        position: absolute;
        top: 5px;
        right: 5px;

    }

    .group-box .two-btns button span {
        font-size: 15px !important;
    }

    .img-box {
        height: 192px
    }

}

/*tab two style*/


.group-box .categories-btn {
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    padding: 5px 17px;
    font-size: 14px;
    font-weight: 400;
    background: #FFFFFF;
    border-radius: 12px;
    /*margin: 5px 7px 5px 0px;*/
    margin: 20px 7px 5px 0px;
    /*white-space: nowrap;*/
}

.breadcrumb-item.active{
    color: #6c2fbb !important;
    font-weight: bold;
    margin: -2px 0 0 0;
}
.firstLi{
    cursor: pointer;
}
.breadcrumb-item+.breadcrumb-item::before {
    display: inline-block;
    padding-right: .5rem;
    color: #6c757d;
    content: ">";
}

.breadcrumb-item+.breadcrumb-item::before {
    display: inline-block;
    padding-right: .5rem;
    color: #6c757d;
    content: "|";
    /* background-image: url('../../../assets/images/right-arrow.svg');
    background-repeat: no-repeat;
    background-size: contain; */
    width: 20px;
    height: 15px;
    margin-top: 8px;
}

@media (max-width: 1600px) {

    .img-box-pub {
        height: 150px
    }
}


@media (max-width: 1400px) {

    .activity-box .tab-box-video ul li {
        font-size: 18px;
        white-space: nowrap;
    }

    .img-box-pub {
        height: 120px;
    }

    .group-box h4 {
        font-size: 18px;
    }

    .group-box .categories-btn {
        font-size: 14px;
        margin: 20px 0;
    }

}

@media (max-width: 1200px) {
    .group-box h4 {
        margin-bottom: 10px;
    }

    .tab-box-video ul {
        overflow-x: auto;
        padding-bottom: 10px;

    }

    .tab-box-video ul::-webkit-scrollbar {
        height: 7px;

    }
}

@media (max-width: 991px) {

    .group-box p {
        line-height: 18px;
    }

    .group-box {
        position: relative;
        margin: 10px 0;
    }

    .video-container {
        padding: 12px;
    }

    .img-box-pub {
        height: 240px;
    }
}

@media (max-width: 768px) {
    .group-box p {
        line-height: 15px;
    }

    .group-box {
        position: relative;
        margin: 10px 0;
    }

    .my-video-draft .tab-box-video ul li {
        font-size: 17px;
    }

    .group-box h4 {
        font-size: 17px;
    }

    .img-box-pub {
        height: 157px;
    }
    .activity-box .tab-box-video ul{
        justify-content: start;
    }
}

@media (max-width: 420px) {
    .group-box h4 {
        font-size: 15px;
    }

    .img-box-pub {
        height: 180px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/user-activitiy/user-activitiy.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;GAEG;AACH;;IAEI,kBAAkB;AACtB;AACA;;;IAGI,qBAAqB;;IAErB,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;;AAE5C;;AAEA,oBAAoB;AACpB,mBAAmB;AACnB,yBAAyB;AACzB,oBAAoB;AACpB,IAAI;;AAEJ;;;;;;;GAOG;AACH;;IAEI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,eAAe;IACf,+CAA+C;IAC/C,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA,sBAAsB;AACtB,uBAAuB;AACvB,IAAI;;AAEJ,qBAAqB;AACrB,uBAAuB;AACvB,0BAA0B;AAC1B,IAAI;;AAEJ,wBAAwB;AACxB,uBAAuB;AACvB,sBAAsB;AACtB,kCAAkC;AAClC,0BAA0B;AAC1B,oBAAoB;AACpB,0BAA0B;;AAE1B,IAAI;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;;AAGA,wCAAwC;;AAExC;IACI,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,6BAA6B;AACjC;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;;AAE3B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;;IAEd;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI;IACJ;;AAEJ;;AAEA,gBAAgB;;;AAGhB;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ;;+BAE2B;IAC3B,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI;QACI;IACJ;AACJ;;;AAGA;;IAEI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;AAEJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;;IAExB;;IAEA;QACI,WAAW;;IAEf;AACJ;;AAEA;;IAEI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".main {\r\n    margin-top: 25px;\r\n    width: 100%;\r\n}\r\n\r\n.container {\r\n    max-width: 1000px;\r\n}\r\n\r\n.video-container {\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    background-color: #ffff;\r\n    height: 66vh;\r\n    margin-top: 40px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n}\r\n\r\n/* .video-container :hover {\r\n    background-color: #fff;\r\n} */\r\n.tab-pane\r\n{\r\n    padding-left: 15px;\r\n}\r\n.reacted\r\n{\r\n   \r\n    width: auto!important;\r\n   \r\n    height: 17px!important;\r\n}\r\n\r\n.nav-pills .nav-link {\r\n    color: #000 !important\r\n}\r\n\r\n.nav-pills .nav-link.active {\r\n    color: #6c2fbb !important;\r\n    background-color: transparenT !important;\r\n\r\n}\r\n\r\n/*.history-row img{*/\r\n/*    width: 100%;*/\r\n/*    object-fit: cover;*/\r\n/*    height: 86px;*/\r\n/*}*/\r\n\r\n/* .history-row {\r\n    \r\n    padding: 15px 0;\r\n    margin: 5px 0px;\r\n    cursor: pointer;\r\n    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);\r\n    \r\n} */\r\n.width-100 {\r\n   \r\n    width: 100%;\r\n    padding: 0px 15px;\r\n    padding: 15px 0;\r\n    margin: 5px 0px;\r\n    cursor: pointer;\r\n    /*box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);*/\r\n    /* margin-bottom: 15px; */\r\n    /* margin-left: 2px; */\r\n}\r\n.width-100:hover {\r\n    background-color: #f8f9fa;\r\n    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%);\r\n    /*border-radius: 10px;*/\r\n}\r\n\r\n.video-img img {\r\n    width: inherit;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n/*.video-details h5 {*/\r\n/*    font-size: 15px;*/\r\n/*}*/\r\n\r\n/*.video-details p {*/\r\n/*    font-size: 12px;*/\r\n/*    margin-bottom: 7px;*/\r\n/*}*/\r\n\r\n/*.video-details span {*/\r\n/*    font-size: 12px;*/\r\n/*    color: #636161;*/\r\n/*    border:  1px solid #636161;*/\r\n/*    border-radius: 4px;*/\r\n/*    padding: 4px;*/\r\n/*    margin-right: 15px;*/\r\n\r\n/*}*/\r\n\r\n.video-desc {\r\n    text-align: justify;\r\n}\r\n\r\n.icon :hover {\r\n    /* fill: #6655ee; */\r\n    fill: #6c2fbb\r\n}\r\n\r\n.icon > svg {\r\n    width: 11%;\r\n    margin-right: 5px;\r\n}\r\n\r\na.active > svg {\r\n    fill: #6c2fbb\r\n}\r\n\r\na.nav-link :hover {\r\n    color: #6c2fbb;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .nav-pills .nav-link {\r\n        margin-bottom: 10px;\r\n    }\r\n}\r\n\r\n\r\n/*new  tab css=========================*/\r\n\r\n.activity-box .tab-box-video {\r\n    width: 100%;\r\n\r\n}\r\n\r\n.activity-box .tab-box-video ul {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.activity-box .tab-box-video ul li {\r\n    list-style: none;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n    padding: 5px 0;\r\n    margin: 0px 25px;\r\n    color: #878395;\r\n    cursor: pointer;\r\n}\r\n\r\n.activity-box .tab-box-video ul li svg {\r\n    fill: #878395;\r\n}\r\n\r\n.activity-box .tab-box-video ul li.active {\r\n    border-top: 3px solid #6c2fbb;\r\n    color: #6c2fbb;\r\n}\r\n\r\n.activity-box .tab-box-video ul li.active svg {\r\n    fill: rgba(108, 47, 187, 1);\r\n}\r\n\r\n\r\n.img-box-pub {\r\n    aspect-ratio: 16/9;\r\n    display: flex;\r\n    justify-content: center;\r\n    /*height: 213px;*/\r\n    position: relative;\r\n    overflow: hidden;\r\n    background: #f8f9fa;\r\n    border-radius: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.img-box-pub img {\r\n    height: 100%;\r\n    object-fit: cover;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.group-box h4 {\r\n    margin-bottom: 20px;\r\n    font-weight: 500;\r\n    color: #0f062b;\r\n    font-size: 16px;\r\n    margin-bottom: 7px;\r\n}\r\n\r\n.group-box p {\r\n    margin: 0;\r\n    font-size: 13px;\r\n    color: rgba(136, 133, 142, 1);\r\n}\r\n\r\n\r\n.two-btns {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    background-color: #000000a2;\r\n    display: flex;\r\n    align-items: center;\r\n    column-gap: 10px;\r\n    padding: 2px 10px;\r\n    border-radius: 5px 10px;\r\n\r\n}\r\n\r\n.two-btns button {\r\n    background-color: transparent;\r\n    display: flex;\r\n    align-items: center;\r\n    column-gap: 5px;\r\n    border: none;\r\n}\r\n\r\n.two-btns button span {\r\n    color: #fff;\r\n    font-size: 12px !important;\r\n}\r\n\r\n@media (max-width: 1400px) {\r\n\r\n    .group-box p {\r\n        line-height: 5px;\r\n    }\r\n\r\n    .group-box .two-btns {\r\n        position: absolute;\r\n        top: 5px;\r\n        right: 5px;\r\n\r\n    }\r\n\r\n    .group-box .two-btns button span {\r\n        font-size: 15px !important;\r\n    }\r\n\r\n    .img-box {\r\n        height: 192px\r\n    }\r\n\r\n}\r\n\r\n/*tab two style*/\r\n\r\n\r\n.group-box .categories-btn {\r\n    color: #6c2fbb;\r\n    border: 1px solid #6c2fbb;\r\n    padding: 5px 17px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    background: #FFFFFF;\r\n    border-radius: 12px;\r\n    /*margin: 5px 7px 5px 0px;*/\r\n    margin: 20px 7px 5px 0px;\r\n    /*white-space: nowrap;*/\r\n}\r\n\r\n.breadcrumb-item.active{\r\n    color: #6c2fbb !important;\r\n    font-weight: bold;\r\n    margin: -2px 0 0 0;\r\n}\r\n.firstLi{\r\n    cursor: pointer;\r\n}\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n    display: inline-block;\r\n    padding-right: .5rem;\r\n    color: #6c757d;\r\n    content: \">\";\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n    display: inline-block;\r\n    padding-right: .5rem;\r\n    color: #6c757d;\r\n    content: \"|\";\r\n    /* background-image: url('../../../assets/images/right-arrow.svg');\r\n    background-repeat: no-repeat;\r\n    background-size: contain; */\r\n    width: 20px;\r\n    height: 15px;\r\n    margin-top: 8px;\r\n}\r\n\r\n@media (max-width: 1600px) {\r\n\r\n    .img-box-pub {\r\n        height: 150px\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 1400px) {\r\n\r\n    .activity-box .tab-box-video ul li {\r\n        font-size: 18px;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .img-box-pub {\r\n        height: 120px;\r\n    }\r\n\r\n    .group-box h4 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .group-box .categories-btn {\r\n        font-size: 14px;\r\n        margin: 20px 0;\r\n    }\r\n\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .group-box h4 {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .tab-box-video ul {\r\n        overflow-x: auto;\r\n        padding-bottom: 10px;\r\n\r\n    }\r\n\r\n    .tab-box-video ul::-webkit-scrollbar {\r\n        height: 7px;\r\n\r\n    }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\r\n    .group-box p {\r\n        line-height: 18px;\r\n    }\r\n\r\n    .group-box {\r\n        position: relative;\r\n        margin: 10px 0;\r\n    }\r\n\r\n    .video-container {\r\n        padding: 12px;\r\n    }\r\n\r\n    .img-box-pub {\r\n        height: 240px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .group-box p {\r\n        line-height: 15px;\r\n    }\r\n\r\n    .group-box {\r\n        position: relative;\r\n        margin: 10px 0;\r\n    }\r\n\r\n    .my-video-draft .tab-box-video ul li {\r\n        font-size: 17px;\r\n    }\r\n\r\n    .group-box h4 {\r\n        font-size: 17px;\r\n    }\r\n\r\n    .img-box-pub {\r\n        height: 157px;\r\n    }\r\n    .activity-box .tab-box-video ul{\r\n        justify-content: start;\r\n    }\r\n}\r\n\r\n@media (max-width: 420px) {\r\n    .group-box h4 {\r\n        font-size: 15px;\r\n    }\r\n\r\n    .img-box-pub {\r\n        height: 180px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
